import { createContext } from 'react';

const TableContext = createContext({ variant: '' });

export default TableContext;
